module.exports = __webpack_public_path__ + "r-v3/img/ml_04_00.85864aba.jpg";